import React, { useEffect, useState } from "react";
import { Col, Form, Row, Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { FetchInvoiseList } from "../../services/ReduxTookit/Slice/InvoiceRedux";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import viewaction from "../../assets/images/viewaction.svg";
import Nodata from "../../component/common-component/Nodata";
import InvoiceDetailsModal from "./InvoiceDetailsModal";

const InvoicesManagementModel = () => {
  const dispatch = useDispatch();

  const currentYear = new Date().getFullYear();
  const previousFiveYears = Array.from(
    { length: 5 },
    (_, i) => currentYear - i
  );

  const [invoiceList, setInvoiceList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [id, setId] = useState(null);
  const [show, setShow] = useState(false);

  const getInvoiceGetList = async (yearInput) => {
    setLoading(true);
    dispatch(FetchInvoiseList(yearInput))
      .then((response) => {
        if (response?.payload?.isValidate) {
          setInvoiceList(response.payload.data?.data?.dataList1 || []);
        } else {
          setInvoiceList([]);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (selectedYear) {
      getInvoiceGetList(selectedYear);
    }
  }, [selectedYear]);

  const closeModel = () => {
    setId(null);
    setSelectedMonth("");
    setShow(!show);
  };

  return (
    <>
      <div className="header-search-input searchplaceholder purchaseSearch invoice-management">
        <div className="d-flex justify-content-end align-items-center w-50 gap-2">
          <p className="text-end w-100">Select Year :</p>

          <Form.Select
            id="year"
            className="common-select"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            {previousFiveYears?.length > 0 &&
              previousFiveYears?.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
          </Form.Select>
        </div>
      </div>

      <div className="purchases-profile-main">
        <div className="table-wrapper-main setting-table-main">
          <div className="profile-common-title"></div>
          <Table responsive>
            <thead>
              <tr>
                <th>Month</th>
                <th className="text-end">Amount</th>
                <th className="text-end sticky-actions">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <Loader type={LoaderType.TableRow} count={6} nooftd={3} />
              ) : invoiceList.length > 0 ? (
                invoiceList.map((item) => (
                  <tr key={item?.earningid}>
                    <td className="text-start">{item?.month}</td>
                    <td className="text-end">${item?.amount}</td>
                    <td className="sticky-actions">
                      <div className="all-actions">
                        <img
                          src={viewaction}
                          title="Download"
                          alt="Download"
                          onClick={() => {
                            setSelectedMonth(item?.month);
                            setId(item?.earningid);
                            setShow(true);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3}>
                    <Nodata />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {show && (
        <InvoiceDetailsModal
          selectedMonth={selectedMonth}
          selectedYear={selectedYear}
          showModal={show}
          closeModel={closeModel}
          payload={id}
        />
      )}
    </>
  );
};

export default InvoicesManagementModel;
